import { getAppState } from '@disco/accounts/utils/api'
import { useEffect, useState } from 'react'

type AppState = {
  database_readonly_mode: boolean
  modules_state: {
    signups: boolean
  }
}

const initialAppState = {
  database_readonly_mode: false,
  modules_state: {
    signups: true,
  },
}

export const useAppState = () => {
  const [data, setData] = useState<AppState>(initialAppState)

  useEffect(() => {
    async function fetchAppState() {
      try {
        const appState = (await getAppState()) as AppState
        setData(appState)
      } catch {
        setData(initialAppState)
      }
    }

    fetchAppState()
  }, [])

  return data
}
